export default {
  'login.Release your inner lion and let it roar': '释放内心雄狮，尽情狮吼！',
  'login.Log In': '登录',
  'login.Please input Lion ID': '请输入LLID',
  'login.Please enter your password': '请输入密码',
  'login.Password': '密码',
  'login.Remember my information': '记住我的信息',
  'login.Register': '注册',
  'login.Forget Password': '忘记密码',
  'login.Registration': '注册',
  'login.Send Code': '发送验证码',
  'login.Email': '邮箱地址',
  'login.Verification code': '验证码',
  'login.Please enter the Vertification code received from the email':
    '请输入邮箱中收到的验证码',
  'login.Confirm password': '确认密码',
  'login.Submit': '提交',
  'login.Reset your password': '重设密码',
  'login.Please input a Valid Lion ID': '请输入有效的LLID',
  'login.Password must be 8-12 characters,no spaces and must contain at lease 3 of these characters:1 uppercase,1 lowercase,1 number':
    '密码为8-12位，不能有空格且必须同时包含大写字母、小写字母、数字',
  'login.Return to Login Page': '返回登录界面',
  'login.Your password do not match. Please try again':
    '您所填写的密码不匹配。请再试一次',
  'login.Registered Successfully': '注册成功',
  'login.Password Reset Successfully': '密码已重置',
}
